<template>
  <v-card class="stat-card" elevation="0">
    <div class="stat-card__content">
      <div v-if="icon" class="stat-card__icon-wrapper">
        <v-avatar size="56" class="stat-card__icon">
          <v-img :src="icon"></v-img>
        </v-avatar>
      </div>
      <div class="stat-card__info">
        <div class="stat-card__label">{{ title }}</div>
        <div class="stat-card__value">
          {{ formatValue(value) }}
          <span v-if="isPrice" class="stat-card__currency">FCFA</span>
        </div>
      </div>
    </div>
    <div class="stat-card__decoration"></div>
  </v-card>
</template>

<script>
export default {
  name: "CardStat",
  props: ["title", "icon", "value", "isPrice"],
  methods: {
    formatValue(value) {
      if (value === null || value === undefined) return '0';
      if (typeof value === 'number') {
        return value.toLocaleString('fr-FR');
      }
      return value;
    }
  }
};
</script>

<style scoped>
/* Stat Card */
.stat-card {
  border-radius: 20px;
  background: white;
  border: 2px solid rgba(15, 23, 42, 0.08);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  height: 100%;
}

.stat-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.12);
  border-color: rgba(21, 158, 114, 0.3);
}

.stat-card__content {
  padding: 28px;
  display: flex;
  align-items: center;
  gap: 20px;
  position: relative;
  z-index: 1;
}

.stat-card__icon-wrapper {
  flex-shrink: 0;
}

.stat-card__icon {
  background: linear-gradient(135deg, rgba(21, 158, 114, 0.1), rgba(21, 158, 114, 0.05));
  border: 2px solid rgba(21, 158, 114, 0.2);
  transition: all 0.3s ease;
}

.stat-card:hover .stat-card__icon {
  transform: scale(1.1) rotate(5deg);
  border-color: rgba(21, 158, 114, 0.4);
  box-shadow: 0 4px 12px rgba(21, 158, 114, 0.2);
}

.stat-card__info {
  flex: 1;
  min-width: 0;
}

.stat-card__label {
  font-family: "Montserrat";
  font-weight: 700;
  font-size: 13px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  line-height: 1.2;
}

.stat-card__value {
  font-family: "Montserrat";
  font-weight: 900;
  font-size: 32px;
  color: #0f172a;
  line-height: 1;
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.stat-card__currency {
  font-size: 16px;
  font-weight: 700;
  color: #159e72;
}

.stat-card__decoration {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #159e72, #0c2461);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.stat-card:hover .stat-card__decoration {
  transform: scaleX(1);
}

/* Responsive */
@media (max-width: 768px) {
  .stat-card__content {
    flex-direction: column;
    text-align: center;
    padding: 24px 20px;
  }
  
  .stat-card__value {
    font-size: 28px;
    justify-content: center;
  }
  
  .stat-card__label {
    font-size: 12px;
  }
}
</style>
